// Small stat cards on the Home page: shows quick numbers like sample count and records.

import "../../styles/Home.css";

function StatPills({ stats }) {
  return (
    <div className="statPills" role="list">
      {stats.map((s) => (
        <div key={s.label} className="statPills__pill" role="listitem">
          <div className="statPills__value">{s.value}</div>
          <div className="statPills__label">{s.label}</div>
        </div>
      ))}
    </div>
  );
}

export default StatPills;
